/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";
import React from "react";
import { CardBase } from "ui/CardBase";
import { convertBrToLineBreakCode } from "utility/convertBrTo";

import {
  dateStyle,
  headerStyle,
  labelWrapperStyle,
  openStyle,
  artistsStyle,
  timeStyle,
  titleStyle,
} from "./styles";
import { useThis } from "./useThis";

import type { FcWithoutChildren } from "../../types/fcWithoutChildren";
import type { Props } from "./props";

export const EventCard: FcWithoutChildren<Props> = (props) => {
  const { imagePath, labelComponent, artists } = props;

  const {
    convertedTitle,
    dateDisplay,
    dateForTimeAttribute,
    dayDisplay,
    timeDisplay,
  } = useThis(props);
  return (
    <CardBase
      imageElement={
        imagePath === null ? null : <img src={imagePath} alt={convertedTitle} />
      }
    >
      <header css={headerStyle}>
        <time css={dateStyle} dateTime={dateForTimeAttribute}>
          {dateDisplay}({dayDisplay})
        </time>
        <span css={openStyle}>OPEN</span>
        <time css={timeStyle} dateTime={timeDisplay}>
          {timeDisplay}
        </time>
        {labelComponent ? (
          <span css={labelWrapperStyle}>{labelComponent}</span>
        ) : null}
      </header>

      <h3 css={titleStyle}>{convertedTitle}</h3>

      <footer css={artistsStyle}>
        {artists.map(convertBrToLineBreakCode).join("、")}
      </footer>
    </CardBase>
  );
};
